import type { ListingType } from '@shopexperts/legacy-api';

type ExpertTypeAppearance = {
  label: string;
  statsAccentClass: string;
  avatarRingClass: string;
  typeTextClass: string;
};

export const expertTypeAppearance: Record<ListingType, ExpertTypeAppearance> = {
  freelancer: {
    label: 'Freelancer',
    statsAccentClass: 'bg-violet-100 text-violet-600',
    avatarRingClass: 'ring-violet-600',
    typeTextClass: 'text-violet-600',
  },
  agency: {
    label: 'Agency',
    statsAccentClass: 'bg-blue-100 text-blue-600',
    avatarRingClass: 'ring-blue-600',
    typeTextClass: 'text-blue-600',
  },
  app_service_provider: {
    label: 'App Service',
    statsAccentClass: 'bg-teal-100 text-teal-600',
    avatarRingClass: 'ring-teal-600',
    typeTextClass: 'text-teal-600',
  },
};

const defaultExpertTypeAppearance: ExpertTypeAppearance = {
  label: 'Expert',
  statsAccentClass: 'bg-gray-100 text-gray-600',
  avatarRingClass: 'ring-gray-200',
  typeTextClass: 'text-gray-600',
};

export function getExpertTypeAppearance(listingType?: string | null): ExpertTypeAppearance {
  if (!listingType) return defaultExpertTypeAppearance;
  return expertTypeAppearance[listingType as ListingType] ?? defaultExpertTypeAppearance;
}
